import * as React from "react";
import type { SVGProps } from "react";
const SvgPaypalBlock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 35 25"
    {...props}
  >
    <rect
      width={34}
      height={23}
      x={0.5}
      y={0.518}
      fill="#fff"
      stroke="#D9D9D9"
      rx={3.5}
    />
    <path
      fill="#253B80"
      fillRule="evenodd"
      d="M9.9 15.259H8.344a.216.216 0 0 0-.213.182l-.63 3.99a.13.13 0 0 0 .129.149h.743a.216.216 0 0 0 .213-.183l.17-1.076a.216.216 0 0 1 .213-.182h.493c1.024 0 1.616-.496 1.77-1.479q.104-.647-.198-1.004c-.221-.26-.613-.397-1.134-.397m.18 1.457c-.086.558-.512.558-.924.558H8.92l.164-1.043a.13.13 0 0 1 .129-.109h.107c.281 0 .546 0 .683.16.082.096.107.238.075.434m4.47-.018h-.745a.13.13 0 0 0-.128.11l-.033.208-.052-.076c-.161-.234-.52-.312-.88-.312-.823 0-1.526.623-1.663 1.498-.071.436.03.853.277 1.144.227.268.552.38.939.38.663 0 1.03-.427 1.03-.427l-.032.207a.13.13 0 0 0 .127.15h.672a.216.216 0 0 0 .213-.183l.403-2.55a.13.13 0 0 0-.128-.15m-1.038 1.45a.83.83 0 0 1-.84.711c-.217 0-.39-.07-.5-.2-.111-.131-.153-.317-.118-.524a.834.834 0 0 1 .835-.717c.211 0 .383.07.497.203.113.134.158.32.126.527m4.257-1.45h.749a.13.13 0 0 1 .106.203l-2.49 3.594a.22.22 0 0 1-.178.093h-.747a.13.13 0 0 1-.106-.205l.775-1.094-.824-2.42a.13.13 0 0 1 .123-.171h.735c.096 0 .18.063.208.154l.438 1.461 1.032-1.52a.22.22 0 0 1 .179-.095"
      clipRule="evenodd"
    />
    <path
      fill="#179BD7"
      fillRule="evenodd"
      d="m25.886 19.43.638-4.062a.13.13 0 0 1 .128-.11h.718c.08 0 .14.072.128.15l-.63 3.989a.216.216 0 0 1-.213.183h-.642a.13.13 0 0 1-.128-.15m-4.89-4.171H19.44a.216.216 0 0 0-.213.182l-.63 3.989a.13.13 0 0 0 .128.15h.799a.15.15 0 0 0 .15-.128l.178-1.13a.216.216 0 0 1 .213-.183h.492c1.025 0 1.616-.496 1.771-1.479.07-.43.003-.768-.198-1.004-.221-.26-.613-.398-1.134-.398m.18 1.456c-.085.559-.512.559-.924.559h-.235l.165-1.043a.13.13 0 0 1 .128-.11h.107c.281 0 .546 0 .683.16.082.097.107.238.075.434m4.47-.017H24.9a.13.13 0 0 0-.128.109l-.032.208-.053-.075c-.161-.234-.52-.312-.88-.312-.823 0-1.526.623-1.663 1.498-.07.436.03.853.278 1.144.227.268.552.379.938.379.663 0 1.031-.427 1.031-.427l-.033.207a.13.13 0 0 0 .128.15h.671a.216.216 0 0 0 .213-.182l.403-2.55a.13.13 0 0 0-.128-.15m-1.038 1.45a.83.83 0 0 1-.841.71c-.216 0-.39-.069-.5-.2-.11-.13-.152-.317-.117-.524a.834.834 0 0 1 .835-.716c.211 0 .383.07.497.202a.64.64 0 0 1 .126.527"
      clipRule="evenodd"
    />
    <path
      fill="#253B80"
      d="m15.657 13.831.191-1.214-.426-.01h-2.034l1.414-8.964a.116.116 0 0 1 .115-.098h3.43c1.138 0 1.924.237 2.334.705.193.219.315.448.375.7.062.265.063.582.002.967l-.004.029v.247l.192.109q.241.128.39.297c.164.187.27.426.316.708.046.291.03.637-.046 1.029-.087.45-.23.843-.42 1.164q-.267.444-.668.731a2.7 2.7 0 0 1-.899.406c-.331.086-.709.13-1.123.13h-.267a.808.808 0 0 0-.794.678l-.02.108-.338 2.141-.016.079c-.004.025-.01.037-.02.046a.06.06 0 0 1-.036.012z"
    />
    <path
      fill="#179BD7"
      d="M21.428 5.975q-.015.098-.035.2c-.452 2.323-2 3.125-3.976 3.125H16.41a.49.49 0 0 0-.483.414l-.515 3.268-.146.926a.257.257 0 0 0 .254.298h1.785a.43.43 0 0 0 .424-.362l.018-.09.336-2.133.022-.117a.43.43 0 0 1 .424-.363h.267c1.729 0 3.083-.702 3.478-2.734.166-.849.08-1.557-.357-2.056a1.7 1.7 0 0 0-.489-.376"
    />
    <path
      fill="#222D65"
      d="M20.955 5.786a4 4 0 0 0-.44-.098 5.6 5.6 0 0 0-.887-.064h-2.689a.426.426 0 0 0-.424.362l-.572 3.623-.016.105a.49.49 0 0 1 .483-.414h1.006c1.977 0 3.525-.802 3.977-3.124q.02-.103.035-.201a2.4 2.4 0 0 0-.473-.19"
    />
    <path
      fill="#253B80"
      d="M16.516 5.986a.43.43 0 0 1 .423-.362h2.689q.479-.001.887.065a4 4 0 0 1 .44.097l.102.032q.2.066.371.157c.135-.859 0-1.443-.465-1.972-.511-.583-1.435-.832-2.616-.832h-3.43a.49.49 0 0 0-.485.414l-1.428 9.056c-.028.18.11.341.29.341h2.118l.532-3.373z"
    />
  </svg>
);
export default SvgPaypalBlock;
